$(document).ready(function(){
 
    $('html').removeAttr("style");

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) { // Esc
            var nav_span = $(".nav-span");
            nav_span.removeClass("nav-cross");
            nav_span.addClass("nav-lines");
            $('body').removeClass('nav-toggle-is-active');
            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps
            $('#searchContainer').removeClass("active");
            //$('body').removeClass('fixedBody');
            //$('.header-overlay').hide();  
            $('#protectedDownloadsModal').modal('hide');

        }
    });

    if ($('.fancybox').length)
    {
        $(".fancybox").fancybox(
        {
            openEffect: "none",
            closeEffect: "none"
        });
    }



    $( '#loadLDE' ).on( 'click', function (e) 
    {
        e.preventDefault();
 
        var url = "/learning-development/story.html";
        $('#ldeIframe').attr('src', url);
        // virtual analytics pages for the iFrame
        if (window.gaID && window.gaID !== undefined && window.gaID !== '' )
        {
            var step_title = "Learning and Development";
            var step_slug =  "/virtual/lde/";
            gtag('config', window.gaID, 
            {
                'page_path': step_slug,
                'page_title': step_title
            });

        }

    });


});
